<template>
  <div>
      <AccountComponent ></AccountComponent>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AccountComponent from "@/components/AccountComponent";
export default {
name:"Account",
  
  //********************** */ 
  components: {
      AccountComponent
  },

  //********************** */
  data: () => ({

  }),

  //********************** */
  computed: {
    ...mapGetters("Account", {
      isRegistered: "isRegistered",
    }),
  },

  //********************** */
  methods: {
    
  },

  //*********************** */
  async mounted() {
      
  },
}
</script>

<style>

</style>